import { ShieldCheck } from 'lucide-react';

/**
 * Marks a screen as part of the v3 "Secure Access" (ZTNA) plane, distinct from
 * the v2 SD-WAN plane. Per UI-DESIGN-v3-access.md §2 (Decision D1): every Secure
 * Access surface carries this chip so a v3 screen is recognisable at a glance
 * without renaming anything in v2. Teal is the v3 accent throughout.
 */
const ZtnaChip = ({ className = '' }: { className?: string }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full border border-teal-200 bg-teal-50 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-teal-700 ${className}`}
    title="Zero Trust Network Access — the v3 Secure Access plane"
  >
    <ShieldCheck className="h-3 w-3" />
    ZTNA
  </span>
);

export default ZtnaChip;
